import styled from 'styled-components'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

export const ToastWrapper = styled.div`
    [data-sonner-toaster] {
        font-family:
            'Inter',
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            'Roboto',
            sans-serif;
    }

    [data-sonner-toast] {
        ${getFontStyle('p02Regular')}
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
        background-color: ${colors.primaryWhite} !important;
        color: ${colors.primary70} !important;
        border: none !important;
        box-shadow:
            0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;

        [data-title] {
            ${getFontStyle('p02Medium')}
            color: ${colors.primary80} !important;
        }

        [data-description] {
            ${getFontStyle('p03Regular')}
            color: ${colors.primary60} !important;
        }

        [data-button] {
            ${getFontStyle('p03Medium')}
            background-color: ${colors.primary10} !important;
            color: ${colors.primary70} !important;

            &:hover {
                background-color: ${colors.primary20} !important;
            }
        }

        [data-close-button] {
            background-color: transparent !important;
            border: none !important;

            &:hover {
                background-color: ${colors.primary10} !important;
            }

            svg {
                color: ${colors.primary50} !important;
            }
        }

        /* Override rich colors - keep icons colored but use white background */
        &[data-type='success'] {
            background-color: ${colors.primaryWhite} !important;

            [data-icon] {
                color: ${colors.green60} !important;
            }
        }

        &[data-type='error'] {
            background-color: ${colors.primaryWhite} !important;

            [data-icon] {
                color: ${colors.lobster60} !important;
            }
        }

        &[data-type='warning'] {
            background-color: ${colors.primaryWhite} !important;

            [data-icon] {
                color: ${colors.orange60} !important;
            }
        }

        &[data-type='info'] {
            background-color: ${colors.primaryWhite} !important;

            [data-icon] {
                color: ${colors.primary60} !important;
            }
        }
    }
`
